import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import { RefObject, useState } from "react"
import { comb } from "src/utilities/common"
import { theme, TI } from "src/utilities/theme"

import { DGText } from "../../../../components/common/DGText"
import { s } from "../../../../utilities/common"
import { CategoryScreenFocusKeys } from "../../../Category/category-focus-keys"

export const GlyphButton = ({
  glyph,
  selected,
  scrollRef,
}: {
  glyph: string
  selected: comb<string | undefined>
  scrollRef: RefObject<HTMLElement>
}) => {
  const onPressAction = () => {
    selected.set(glyph)
  }
  const { ref, focused, focusSelf } = useFocusable({
    focusKey: CategoryScreenFocusKeys.GlyphButton + ":" + glyph,
    onFocus: ({ x }, _, query) => {
      onPressAction()
      if (!(query && query.noScroll) && scrollRef.current)
        scrollRef.current.style.transform =
          "translate3d(" + (-x + 537) + "px, 0, 0)"
    },
  })
  const [touched, setTouched] = useState(false)
  return (
    <Box
      aria-label={glyph}
      tabIndex={0}
      onMouseDown={() => focusSelf({ noScroll: true })}
      onMouseEnter={() => setTouched(true)}
      onMouseLeave={() => setTouched(false)}
      ref={ref}
      sx={{
        height: s("88px"),
        width: s("88px"),
        float: "left",
        background: focused
          ? "white"
          : touched || (selected.val && selected.val === glyph)
            ? theme.palette.white[10]
            : "transparent",
        boxShadow: focused
          ? `${s("0px 30px 112px 0px")} rgba(0, 0, 0, 0.60)`
          : undefined,
        borderRadius: s("8px"),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <DGText
        tx={TI.H05tv}
        sx={{
          color: focused ? "black" : theme.palette.white[70],
        }}
      >
        {glyph}
      </DGText>
    </Box>
  )
}
